import { ReactComponent as ITodoReminder } from '@/assets/icons/todo-reminder.svg';
import { ReactComponent as IAddFriendTasks } from '@/assets/icons/add-friend-tasks.svg';
import { ReactComponent as ISOP } from '@/assets/icons/sop.svg';
// import { ReactComponent as IMoments } from '@/assets/icons/moments.svg';

export const launcherList = [
  {
    name: 'reminder',
    title: '待办事项',
    path: '/todo-reminder',
    icon: ITodoReminder,
    themeColor: '#3296FA',
    getUnreadCount: () => 1
  },
  {
    name: 'task',
    title: '加好友任务',
    path: '/add-friend-tasks',
    icon: IAddFriendTasks,
    themeColor: '#44D7B6',
    getUnreadCount: () => 999
  },
  {
    name: 'sop',
    title: 'SOP任务',
    path: '/sop',
    icon: ISOP,
    themeColor: '#F7B500',
    getUnreadCount: () => 999
  },
  // {
  //   name: 'moments',
  //   title: '朋友圈',
  //   path: '/moments',
  //   icon: IMoments,
  //   themeColor: '#07C160',
  //   getUnreadCount: () => 999
  // },
];
